import React from 'react';
import OInput from '../../../UI/FormControls/OInput';

const Inputs = ({ formData, setFormData }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          marginBottom: '20px',
          flexWrap: 'wrap',
        }}
      >
        <OInput
          label="Proizvođač"
          name="naziv"
          value={formData.naziv}
          handleChange={handleInputChange}
          style={{ width: '300px', marginRight: '10px' }}
        />
        <OInput
          label="Šifra mašine"
          name="sifra"
          value={formData.sifra}
          handleChange={handleInputChange}
          style={{ width: '300px', marginRight: '10px' }}
        />
      </div>
    </div>
  );
};

Inputs.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default Inputs;
